export default {
  columnHeader: {
    simulatedDuration: 'Simulated duration',
  },
  acceptSimulatedDuration: 'Accept simulated duration: {0}',
};
